import * as braze from '@braze/web-sdk';
import { Box, Center } from '@chakra-ui/react';
import loadable from '@loadable/component';
import CryptoJS from 'crypto-js';
import { motion } from 'framer-motion';
import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { useAppDispatch, useTypedSelector } from '../../hooks/store';
import useDomain from '../../hooks/useDomain';
import LoadingBackground from '../../images/background/loading-background.png';
import { ReactComponent as LoadingSkytrak } from '../../images/icons/icon-loading-skytrak.svg';
import {
  selectContentDynamicHome,
  setStatusContentCards,
} from '../../slices/dynamicContentHome';
import { changeESNInput } from '../../slices/skytrak';
import {
  changeStatusEmbedOnProd,
  changeStatusEmbedOnQA,
  selectStatusEmbedOnProd,
} from '../../slices/support';
import {
  changeStatusLoginByTicket,
  selectAuthenticationStatus,
  selectUserData,
  setCrossDomainToken,
  setIsAuthenticated,
  signInWithTicket,
  signOut,
  sytrakSignInWithTicket,
} from '../../slices/user';
import './PrivateRoute.css';
import {
  selectIsSkytrakApp,
  selectIsSkytrakIOS,
  selectIsTabletApp,
} from '../../slices/config';

// const ModalShowError = loadable(() => import('../ModalShowError'));
const SupportModal = loadable(() => import('../SupportModal'));
const CookiePolicies = loadable(
  () => import('../../components/CookiePolicies')
);
const WaitingSlotModal = loadable(() => import('../WaitingSlotModal'));
const PrivacyTerms = loadable(() => import('../PrivacyTermsOfService'));
const PrivateRouteNotLogin = loadable(() => import('./PrivateRouteNotLogin'));
const ModalBuyGolftecPlus = loadable(
  () =>
    import(
      '../../pages/MyAccount/Account/Subscription/GolftecPlus/ModalBuyGolftecPlus'
    )
);

// const MotionBox = motion(Box);

// const variants = {
//   enter: {
//     opacity: 1,
//   },
//   exit: {
//     opacity: 0,
//   },
// };

const PrivateRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  const [isAuthenticated, userData, dataDynamicHome] = [
    useTypedSelector(selectAuthenticationStatus),
    useTypedSelector(selectUserData),
    useTypedSelector(selectContentDynamicHome),
  ];
  const domain = useDomain();
  const skytrakTicket = searchParams.get('skytrakTicket');
  const modeEmbedOnProd = useTypedSelector(selectStatusEmbedOnProd);
  const { pathname } = useLocation();
  const [initBraze, setInitBraze] = useState(false);
  const isTabletApp = useTypedSelector(selectIsTabletApp);
  const isSkytrakApp = useTypedSelector(selectIsSkytrakApp);
  const isSkytrakIOS = useTypedSelector(selectIsSkytrakIOS);

  const isSkytrakDomain = useMemo(() => {
    if (domain === 'skytrak') {
      return true;
    }
    return false;
  }, [domain]);

  // useEffect(() => {
  //   const metaRemove = document.getElementById('zoom-meta');
  //   const meta = document.createElement('meta');
  //   meta.setAttribute('name', 'zoom-domain-verification');
  //   meta.setAttribute('content', 'ZOOM_verify_ZhLTgylynGpcyI03D3Oe19');
  //   meta.id = 'zoom-meta';
//   if (isSkytrakDomain) {
  //     if (!metaRemove) {
  //       document.head.appendChild(meta);
  //     }
  //   }
  // }, [isSkytrakDomain, modeEmbedOnProd, userData]);

  // useEffect(() => {
  //   const scriptRemove = document.getElementById('zoom-chat');
  //   const script = document.createElement('script');
  //   script.src = 'https://us01ccistatic.zoom.us/us01cci/web-sdk/chat-client.js';
  //   script.type = 'text/javascript';
  //   script.setAttribute('data-chat-entry-id', 'q8I6GOmoTgm5Xz5yR3tiIg');
  //   script.setAttribute('data-el', '#chat');
  //   script.id = 'zoom-chat';
  //   if (isAuthenticated && userData && !modeEmbedOnProd) {
  //     if (!scriptRemove) {
  //       if (isSkytrakDomain) {
  //         const person = {
  //           customerName: `${userData.firstName} ${userData.lastName}`,
  //           customerEmail: userData.email,
  //           customerId: userData.customerId,
  //           playerId: userData.playerId,
  //           survey: {
  //             nickName: userData.nickname,
  //             email: userData.email,
  //             customerId: userData.customerId,
  //             playerId: userData.playerId,
  //           },
  //         };
  //         window.localStorage.setItem(
  //           'q8I6GOmoTgm5Xz5yR3tiIg:user',
  //           JSON.stringify(person)
  //         );
  //       }
  //       if (!isSkytrakDomain) {
  //         document.head.appendChild(script);
  //       }
  //     }
  //   } else {
  //     if (!isAuthenticated) {
  //       const body = document.getElementsByTagName('body');
  //       if (scriptRemove) {
  //         Array.from(body[0].children).find(
  //           (element) =>
  //             element.tagName.match(/LIVESDK-CHAT|livesdk-chat/) &&
  //             element.remove()
  //         );
  //         scriptRemove.remove();
  //         window.localStorage.removeItem('q8I6GOmoTgm5Xz5yR3tiIg:user');
  //       }
  //     }
  //   }
  // }, [isAuthenticated, isSkytrakDomain, modeEmbedOnProd, userData]);

  // useEffect(() => {
  //   if (
  //     isAuthenticated &&
  //     eToken &&
  //     customerCart === null &&
  //     loadingCustomerCart === 'success'
  //   ) {
  //     onOpen();
  //   }
  // }, [isAuthenticated, eToken, customerCart, loadingCustomerCart, onOpen]);

  const ticket = searchParams.get('ticket');
  const registerESN = searchParams.get('registerESN');
  const renewal = searchParams.get('renewal');
  const authToken = searchParams.get('authToken');
  const embedOnProd = searchParams.get('embedOnProd');
  const embedOnQA = searchParams.get('embedOnQA');

  useEffect(() => {
    if (authToken) {
      const bytes = CryptoJS.AES.decrypt(authToken, 'clubhouse', {
        keySize: 128 / 8,
        iv: CryptoJS.enc.Hex.parse('clubhouse'),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      const { access_token } = decryptedData[0];

      dispatch(setCrossDomainToken(access_token));
      dispatch(setIsAuthenticated(true));
      window.location.href = '/';
    }
  }, [authToken, dispatch]);

  useEffect(() => {
    if (ticket) {
      dispatch(signOut());
      dispatch(changeStatusLoginByTicket(true));
      if (embedOnProd === 'true') {
        dispatch(changeStatusEmbedOnProd(true));
        dispatch(changeStatusEmbedOnQA(false));
      }
      if (embedOnQA === 'true') {
        dispatch(changeStatusEmbedOnQA(true));
        dispatch(changeStatusEmbedOnProd(false));
      }
      dispatch(signInWithTicket(ticket))
        .unwrap()
        .then(() => {
          // dispatch(fetchUserData());
          if (location.search && location.search.match('product_action')) {
            if (location.search.match('product_action')) {
              navigate(
                {
                  pathname: location.pathname,
                  search: 'product_action=addToCart',
                },
                {
                  replace: true,
                }
              );
            }
          } else {
            navigate(location.pathname, { replace: true });
          }
        })
        .catch(() => navigate('/login'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    embedOnProd,
    embedOnQA,
    location,
    location.pathname,
    searchParams,
    ticket,
  ]);

  useEffect(() => {
    if (skytrakTicket) {
      dispatch(signOut());
      dispatch(changeStatusLoginByTicket(true));
      dispatch(sytrakSignInWithTicket(decodeURI(skytrakTicket)))
        .unwrap()
        .then(async () => {
          // dispatch(fetchUserData());
          if (registerESN) {
            dispatch(changeESNInput(registerESN));
            localStorage.setItem('registerESN', registerESN);
            navigate('/my-device');
          } else if (renewal === 'true') {
            localStorage.setItem('renewal', renewal);
            navigate('/my-device');
          } else {
            navigate(location.pathname, { replace: true });
          }
        })
        .catch(() => {
          navigate('/login');
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, registerESN, renewal, skytrakTicket]);

  useEffect(() => {
    const { Notification } = window as any;
    if (
      Notification &&
      Notification.permission !== 'granted' &&
      Notification.permission !== 'denied'
    ) {
      Notification.requestPermission();
    }
  }, []);

  const initalizeBraze = useCallback(() => {
    braze.destroy();
    if (window.location.hostname.match(/dev|qa/)) {
      braze.initialize('d6d5638d-4a9d-499f-ba5b-3b87a6480403', {
        baseUrl: 'sdk.iad-06.braze.com',
        safariWebsitePushId: 'web.com.golftec.clubhouse',
        enableLogging: true,
      });
    } else {
      braze.initialize('b8d70f85-d5c0-4a82-9e07-ec210ea1850f', {
        baseUrl: 'sdk.iad-06.braze.com',
        safariWebsitePushId: 'web.com.golftec.clubhouse',
        enableLogging: true,
      });
    }

    braze.openSession();

    braze.subscribeToContentCardsUpdates(function (event: braze.ContentCards) {
      console.log(event);
    });
    braze.requestContentCardsRefresh();
    userData && braze.changeUser(userData.playerId);
    braze.requestPushPermission();
    // braze.automaticallyShowInAppMessages();
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { coords } = position;
        braze
          .getUser()
          ?.setLastKnownLocation(
            coords.latitude,
            coords.longitude,
            coords.accuracy,
            coords.altitude ? coords.altitude : 0,
            coords.altitudeAccuracy ? coords.altitudeAccuracy : 0
          );
      },
      () => {},
      {
        timeout: 1000,
        maximumAge: 300000,
      }
    );
    navigator.geolocation.watchPosition(
      (position) => {
        const { coords } = position;
        braze
          .getUser()
          ?.setLastKnownLocation(
            coords.latitude,
            coords.longitude,
            coords.accuracy,
            coords.altitude ? coords.altitude : 0,
            coords.altitudeAccuracy ? coords.altitudeAccuracy : 0
          );
      },
      () => {},
      {
        timeout: 1000,
        maximumAge: 300000,
      }
    );
    setInitBraze(true);
    dispatch(setStatusContentCards(true));
  }, [userData, dispatch]);

  useEffect(() => {
    if (
      !window.location.hostname.match(/skytrakgolf/) &&
      isAuthenticated &&
      !initBraze &&
      dataDynamicHome &&
      userData
    ) {
      initalizeBraze();
    }
  }, [initBraze, isAuthenticated, initalizeBraze, dataDynamicHome, userData]);

  useEffect(() => {
    navigator.serviceWorker &&
      navigator.serviceWorker.addEventListener('message', async (event) => {
        if (event.data.push_notification) {
          dispatch(setStatusContentCards(false));
          setInitBraze(false);
        }
      });
  }, [initalizeBraze, dispatch]);

  const connectDeepLink = useCallback(() => {
    const deepLink = localStorage.getItem('deepLink');
    // const productSku = localStorage.getItem('productSku');
    // const discountCode = localStorage.getItem('discountCode');
    if (deepLink) {
      // if (eToken) {
      //   if (productSku && discountCode) {
      //     dispatch(getProductDetailBySku({ sku: productSku }))
      //       .unwrap()
      //       .then((res) => {
      //         if (res?.data && res.data.products?.items?.length > 0) {
      //           navigate(
      //             `/shop/product-detail/${res.data.products.items[0].url_key}/?product_action=addToCart&code=${discountCode}`
      //           );
      //           localStorage.removeItem('deepLink');
      //           localStorage.removeItem('productSku');
      //           localStorage.removeItem('discountCode');
      //         }
      //       })
      //       .catch(() => navigate('/ecommerce'));
      //   } else if (
      //     discountCode &&
      //     customerCart &&
      //     customerCart.items &&
      //     customerCart.items.length > 0
      //   ) {
      //     navigate('/shop');
      //     localStorage.removeItem('deepLink');
      //   } else {
      //     navigate(deepLink);
      //     localStorage.removeItem('deepLink');
      //   }
      // } else {
      navigate(deepLink);
      localStorage.removeItem('deepLink');
      // }
    }
  }, [navigate]);

  useEffect(() => {
    if (isAuthenticated && userData) {
      if (!userData.isForTest) {
        let isAuthorized = true;
        if (userData.account) {
          if (!userData.ageAffirmation)
            isAuthorized = !!(userData.age && parseInt(userData.age) >= 18);
        } else if (!userData.consent) {
          if (!userData.ageAffirmation)
            isAuthorized = !!(userData.age && parseInt(userData.age) >= 18);
        }
        if (
          userData.wuci === userData.account &&
          !userData.birthday &&
          !userData.ageAffirmation
        ) {
          navigate('/age-affirmation');
        } else if (!isAuthorized) {
          navigate('/children-privacy');
        } else if (userData.needVerifyAccount || userData.needChangeEmail) {
          navigate('/verify-email');
        } else if (userData.readTermOfUse) {
          navigate('/terms-and-conditions');
        } else {
          connectDeepLink();
        }
      } else {
        connectDeepLink();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connectDeepLink, isAuthenticated, userData]);

  // useEffect(() => {
  //   if (isAuthenticated && eToken) {
  //     const discountCode = searchParams.get('code');
  //     if (discountCode) {
  //       localStorage.setItem('discountCode', discountCode);
  //       navigate('/shop');
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isAuthenticated, eToken, searchParams]);

  useEffect(() => {
    if (!isAuthenticated) {
      // if (location.pathname.match(/apply-discount/)) {
      //   const sku = searchParams.get('sku');
      //   const discountCode = searchParams.get('code');
      //   if (sku) {
      //     localStorage.setItem('productSku', sku);
      //   }
      //   if (discountCode) {
      //     localStorage.setItem('discountCode', discountCode);
      //   }
      //   localStorage.setItem('deepLink', location.pathname + location.search);
      // } else
      // {
      //   localStorage.setItem('deepLink', location.pathname);
      // }
      localStorage.setItem('deepLink', location.pathname);

      if (
        !modeEmbedOnProd &&
        !(location.pathname && location.pathname.match(/video-library\/series/))
      ) {
        navigate('/login', { state: { from: location } });
      }
    }
  }, [isAuthenticated, location, modeEmbedOnProd, navigate]);

  // useEffect(() => {
  //   if (location.pathname && location.pathname.match('apply-discount')) {
  //     if (location.search.match('sku')) {
  //       const sku = searchParams.get('sku');
  //       if (sku) {
  //         navigate('/shop');
  //         dispatch(getProductDetailBySku({ sku: sku }))
  //           .unwrap()
  //           .then((res) => {
  //             if (res?.data && res.data.products?.items?.length > 0) {
  //               navigate(
  //                 `/shop/product-detail/${res.data.products.items[0].url_key}/${location.search}`
  //               );
  //             }
  //           })
  //           .catch(() => navigate('/ecommerce'));
  //       }
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [location, searchParams]);

  return (
    <>
      {isAuthenticated ? (
        <Box key={1} overflow={{ mobile: 'hidden' }}>
          <Outlet />
          <SupportModal />
          {!isTabletApp && !isSkytrakApp && !isSkytrakIOS && <CookiePolicies />}
          <WaitingSlotModal />
          <PrivacyTerms />
          {/* {customerCart === null && (
            <ModalShowError isOpen={isOpen} onClose={onClose}>
              {(() => {
                return (
                  <VStack spacing={'16px'}>
                    <Box
                      fontWeight={'bold'}
                      fontSize={'17px'}
                      lineHeight={'20px'}
                      letterSpacing={'0.25px'}
                      textTransform={'uppercase'}
                      color={'#54565b'}
                    >
                      {intl.formatMessage({ id: 'NoticeServer' })}
                    </Box>

                    <Box
                      fontSize={'15px'}
                      lineHeight={'20px'}
                      letterSpacing={'0.25px'}
                      color={'#54565B'}
                      textAlign={'center'}
                    >
                      {intl.formatMessage({ id: 'WarningShopNotData' })}
                    </Box>

                    <Button
                      variant={'primary'}
                      width={'100%'}
                      fontWeight={'bold'}
                      fontSize={'13px'}
                      lineHeight={'15px'}
                      letterSpacing={'0.1px'}
                      textTransform={'uppercase'}
                      color={'#ffffff'}
                      height={'44px'}
                      marginTop={'32px !important'}
                      onClick={() => {
                        dispatch(signOut());
                        onClose();
                      }}
                    >
                      {intl.formatMessage({ id: 'GotIt' })}
                    </Button>
                  </VStack>
                );
              })()}
            </ModalShowError>
          )} */}
        </Box>
      ) : !pathname.match(/video-library\/series/) ? (
        <Box>
          {modeEmbedOnProd ? (
            <Box className={'loader'}>
              <Box className={'bar'} />
            </Box>
          ) : (
            <Box
              width={'100%'}
              height={
                'calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom))'
              }
              position={'relative'}
              background={`url(${LoadingBackground}) #36383E no-repeat top right`}
            >
              <Center
                height={
                  'calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom))'
                }
              >
                {isSkytrakDomain ? (
                  <LoadingSkytrak />
                ) : (
                  <motion.svg
                    width="161"
                    height="80"
                    viewBox="0 0 80 31"
                    fill="transparent"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <motion.path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M25.5 2.5C24.6716 2.5 24 3.17157 24 4C24 4.82843 24.6716 5.5 25.5 5.5L31.5 5.5C32.3284 5.5 33 4.82843 33 4C33 3.17157 32.3284 2.5 31.5 2.5H25.5ZM37.5 2.5C36.6716 2.5 36 3.17157 36 4C36 4.82843 36.6716 5.5 37.5 5.5L52.5 5.5C53.3284 5.5 54 4.82843 54 4C54 3.17157 53.3284 2.5 52.5 2.5H37.5Z"
                      fill={'#C0C0C0'}
                      initial={{ x: -2 }}
                      animate={{ x: -1 }}
                      transition={{
                        type: 'tween',
                        repeat: Infinity,
                        repeatType: 'mirror',
                        repeatDelay: 0.1,
                      }}
                    />
                    <motion.path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M16 11C16 10.1716 16.6716 9.5 17.5 9.5L39.5 9.5C40.3284 9.5 41 10.1716 41 11C41 11.8284 40.3284 12.5 39.5 12.5L17.5 12.5C16.6716 12.5 16 11.8284 16 11Z"
                      fill={'#C0C0C0'}
                      initial={{ x: -1 }}
                      animate={{ x: 0 }}
                      transition={{
                        type: 'tween',
                        repeat: Infinity,
                        repeatType: 'mirror',
                        repeatDelay: 0.2,
                      }}
                    />
                    <motion.path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M25 19C25 18.1716 25.6716 17.5 26.5 17.5L38.5 17.5C39.3284 17.5 40 18.1716 40 19C40 19.8284 39.3284 20.5 38.5 20.5L26.5 20.5C25.6716 20.5 25 19.8284 25 19Z"
                      fill={'#C0C0C0'}
                      initial={{ x: -2 }}
                      animate={{ x: -1 }}
                      transition={{
                        type: 'tween',
                        repeat: Infinity,
                        repeatType: 'mirror',
                        repeatDelay: 0.1,
                      }}
                    />
                    <motion.path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21 27C21 26.1716 21.6716 25.5 22.5 25.5L39.5 25.5C40.3284 25.5 41 26.1716 41 27C41 27.8284 40.3284 28.5 39.5 28.5L22.5 28.5C21.6716 28.5 21 27.8284 21 27Z"
                      fill={'#C0C0C0'}
                      initial={{ x: -1 }}
                      animate={{ x: 0 }}
                      transition={{
                        type: 'tween',
                        repeat: Infinity,
                        repeatType: 'mirror',
                        repeatDelay: 0.2,
                      }}
                    />
                    <motion.path
                      d="M47.721 4.24537C59.182 -1.21571 73.8933 -1.72769 78.1698 4.58669C81.42 9.53579 78.683 17.7274 70.301 23.7005L64.9981 26.943C53.366 32.5747 38.9969 32.2334 35.0625 26.6017C30.6149 20.2873 35.9178 9.70645 47.721 4.24537Z"
                      fill=""
                      initial={{ x: -1 }}
                      animate={{ x: 0 }}
                      transition={{
                        type: 'tween',
                        repeat: Infinity,
                        repeatType: 'mirror',
                      }}
                    />
                    <motion.path
                      d="M78.1698 4.58669C73.8933 -1.72769 59.182 -1.21571 47.721 4.24537C35.9178 9.70645 30.6149 20.2873 35.0625 26.6017C38.9969 32.2334 53.366 32.5747 64.9981 26.943C61.919 27.2843 58.8399 27.455 56.4451 27.455C51.1422 27.455 47.0367 26.943 43.9576 25.7484C42.4181 25.2364 39.6811 23.7005 39.8522 21.1406C40.0232 19.2633 41.2207 17.7274 43.2734 16.5328C45.3261 15.3382 47.2078 14.9969 49.2605 14.6556C49.2605 14.6556 48.7473 16.0208 48.5763 17.2154C48.4052 18.41 48.2342 18.922 48.4052 19.6047C48.5763 20.7993 49.2605 21.6526 50.629 22.1645C52.1686 22.6765 54.3924 23.0178 57.4714 23.0178C58.6689 23.0178 60.0374 23.0178 61.0637 22.8472L62.4322 17.3861C60.5505 17.2154 59.011 17.3861 57.4714 17.3861L58.3267 13.9729C64.1428 13.4609 71.8405 14.4849 72.3537 14.4849L70.301 23.7005C78.683 17.7274 81.42 9.53579 78.1698 4.58669ZM71.1563 9.02381C68.0772 8.6825 65.5113 8.34118 62.0901 8.34118C60.0374 8.34118 58.6689 8.51184 56.7872 8.6825C51.4843 9.19447 48.0631 10.3891 45.4972 11.925C42.9313 13.2903 41.0496 14.6555 39.6811 16.3621C43.4445 6.97591 52.8528 4.58669 61.919 4.07471C66.1955 3.90405 69.1036 4.24537 72.1827 4.75734L71.1563 9.02381Z"
                      fill={'#C0C0C0'}
                      initial={{ x: -1 }}
                      animate={{ x: 0 }}
                      transition={{
                        type: 'tween',
                        repeat: Infinity,
                        repeatType: 'mirror',
                      }}
                    />
                  </motion.svg>
                )}
              </Center>
            </Box>
          )}
        </Box>
      ) : (
        <Box>
          <PrivateRouteNotLogin />
        </Box>
      )}
      <ModalBuyGolftecPlus />
    </>
  );
};

export default PrivateRoute;
